import { Component, Input, OnInit } from '@angular/core';
import { ManHourCalculation } from 'src/app/performance-dashboard/model/performance.model';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-man-hour-calculation',
  templateUrl: './man-hour-calculation.component.html',
  styleUrls: ['./man-hour-calculation.component.css']
})
export class ManHourCalculationComponent implements OnInit {

  @Input() ManHourCalculationData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  clonedManHour: { [s: string]: ManHourCalculation } = {};
  ManHourData : any;
  DisableExport : boolean = false;

  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnInit(): void {

  }


  onRowEditInit(data: ManHourCalculation) {
    this.clonedManHour[data.Id] = { ...data };
    this.DisableExport = true;
  }

  onRowEditSave(data: ManHourCalculation, index: number) {
    if (data.Id > 0) {

      if (this.clonedManHour[data.Id].StaffHours != data.StaffHours) {
        this.ManHourCalculationData[this.ManHourCalculationData.length - 1].StaffHours = this.ManHourCalculationData[this.ManHourCalculationData.length - 1].StaffHours - this.clonedManHour[data.Id].StaffHours + data.StaffHours;
      }
      if (this.clonedManHour[data.Id].ContractorHours != data.ContractorHours) {
        this.ManHourCalculationData[this.ManHourCalculationData.length - 1].ContractorHours = this.ManHourCalculationData[this.ManHourCalculationData.length - 1].ContractorHours - this.clonedManHour[data.Id].ContractorHours + data.ContractorHours;
      }
      delete this.clonedManHour[data.Id];
    }
    this.DisableExport = Object.keys(this.clonedManHour).length > 0 ? true : false;
  }

  onRowEditCancel(data: ManHourCalculation, index: number) {
    this.ManHourCalculationData[index] = this.clonedManHour[data.Id];
    delete this.clonedManHour[data.Id];
    this.DisableExport = Object.keys(this.clonedManHour).length > 0 ? true : false;
  }

  GetManHourSelectedDetails(UnitId,Unit,Column){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Man Hour Calculation",
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetManHourSelectedDetails.bind(this));
  }
  callbackMethodForGetManHourSelectedDetails(response){
    if(response.Success)
    this.ManHourData = response.Result;
  }

  Redirect(value,processId)
  {
 // this.router.navigate(['/pob/view-pass-request/'+ value])
 window.open(ConstantsService.URL.APP + ['/pob/view-pass-request/'+value], '_self');
  }
  
  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('ManHourTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws['!ref'] = ws['!ref'].replace('D','C');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "ManHourCalculation.xlsx");

  }
  //EOC Pritesh

}
